import { Box, Paper, Tab, Tabs, Theme, Typography } from '@mui/material';
import { CustomerAnalyticsStyles } from './CustomerAnalyticsStyles';

interface ICustomerAnalyticsHeaderProps {
  selectedAnalyticsType: number;
  setSelectedAnalyticsType: (newType: number) => void;
}

const CustomerAnalyticsHeader: React.FC<ICustomerAnalyticsHeaderProps> = ({
  selectedAnalyticsType,
  setSelectedAnalyticsType
}) => {
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setSelectedAnalyticsType(newValue);
  };

  return (
    <Box sx={CustomerAnalyticsStyles.header}>
      <Typography
        variant="h6"
        sx={{
          background: (theme: Theme) =>
            `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: "bold",
        }}
      >
        Customer Activity Analytics
      </Typography>
      <Paper sx={{ mb: 3 }}>
        <Tabs value={selectedAnalyticsType} onChange={handleChange} aria-label="category tabs">
          <Tab label="Claims" />
          <Tab label="Policy Change Requests" />
        </Tabs>
      </Paper>
    </Box>
  );
};

export default CustomerAnalyticsHeader; 